export default "__VITE_ASSET__FpFMCV5d__"